// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".about__content[data-v-e8ae27cc]{border-radius:12px}.about__description[data-v-e8ae27cc]{max-height:110px;overflow:hidden;white-space:pre-line}.about__description--open[data-v-e8ae27cc]{max-height:unset}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
